import React from 'react';
import { LegalDocument } from '../components/LegalLayout';
import { legalContent } from '../content/legal';
import { useLang } from '../i18n';

const TermsConditions = () => {
  const { lang } = useLang();
  const c = legalContent[lang] || legalContent.en;
  return <LegalDocument doc={c.terms} updated={c.updatedLabel} />;
};

export default TermsConditions;
